export enum VenueSearchTypes {
  BySearch = "bySearch",
  ByVenueCode = "byVenueCode",
  ByManualAddress = "byManualAddress",
}
